import React from "react";
import { FieldProps } from "formik";

export const Checkbox: React.FC<FieldProps<string>["field"]> = ({
  onChange,
  onBlur,
  checked,
  name,
  value
}) => {
  return (
    <>
      <input
        className="sr-only"
        type="checkbox"
        data-testid="welcome-modal-checkbox"
        name={name}
        onChange={onChange}
        onBlur={onBlur}
        checked={checked}
        value={value}
      />
      <span className="checkbox-custom" />
    </>
  );
};
